import { parsePartLine as parsePartLineCore } from "@plaatplan/core";

/** @deprecated Use parsePartLineCore error codes with web.parsePartLine.* keys */
export const PARSE_PART_LINE_ERROR_KEYS = {
  empty: "web.parsePartLine.empty",
  invalidFormat: "web.parsePartLine.invalidFormat",
  lengthMin: "web.parsePartLine.lengthMin",
  widthMin: "web.parsePartLine.widthMin",
  quantityMin: "web.parsePartLine.quantityMin",
};

/**
 * @param {string} text
 * @param {{ unitSystem?: import("@plaatplan/i18n").UnitSystem }} [options]
 */
export function parsePartLine(text, options = {}) {
  const result = parsePartLineCore(text, { unitSystem: options.unitSystem ?? "metric" });
  if (!result.ok) {
    return { ok: false, errorKey: `web.parsePartLine.${result.error}` };
  }
  return result;
}

export function describeParsedPart(part, display) {
  const nameSuffix = part.name ? ` · ${part.name}` : "";
  return display.t("web.parsePartLine.preview", {
    size: display.formatPanelSize(part.length, part.width),
    quantity: part.quantity,
    nameSuffix,
  });
}
